import styled from "styled-components";

const Container = styled.div`
  //   display: flex;
  //   justify-content: flex-end;
  padding: 20px;
  min-width: 380px;
  max-width: 430px;
  background-color: #fff;
  @media (max-width: 720px) {
    min-width: initial;
  }
`;

const BoxText = styled.div`
  margin-bottom: 25px;
`;

export { Container, BoxText };
